export const WorkflowNodeCode = Object.freeze({
  Delay: 'DELAY',
  Wait: 'WAIT',
  CreateTicket: 'CREATE_TICKET',
  UpdateTicket: 'UPDATE_TICKET',
  SendEmail: 'SEND_EMAIL',
  SendSms: 'SEND_SMS',
  SenZns: 'SEND_ZNS',
  SendFacebook: 'SEND_FACEBOOK',
  SendLiveChat: 'SEND_LIVECHAT',
  SendZalo: 'SendZalo',
  PushNotification: 'PUSH_NOTIFICATION',
  CallBot: 'CALL_BOT',
  CreateContact: 'CREATE_CONTACT',
  UpdateContact: 'UPDATE_CONTACT',
  CallAPIWebhook: 'CALL_API_WEBHOOK',
  Branch: 'IF_ELSE',
  Start: 'Start',
  End: 'End',
})

export const WorkflowNodeContext = Object.freeze({
  [WorkflowNodeCode.CreateTicket]: 'Tạo Ticket',
  [WorkflowNodeCode.UpdateTicket]: 'Cập nhật Ticket',
  [WorkflowNodeCode.SendEmail]: 'Gửi Email',
  [WorkflowNodeCode.SendSms]: 'Gửi SMS',
  [WorkflowNodeCode.SenZns]: 'Gửi ZNS',
  [WorkflowNodeCode.SendFacebook]: 'Gửi Chat Facebook',
  [WorkflowNodeCode.SendLiveChat]: 'Gửi LiveChat',
  [WorkflowNodeCode.SendZalo]: 'Gửi Chat Zalo',
  [WorkflowNodeCode.PushNotification]: 'Gửi notification (Web/App)',
  [WorkflowNodeCode.CallBot]: 'Callbot',
  [WorkflowNodeCode.CreateContact]: 'Tạo liên hệ',
  [WorkflowNodeCode.UpdateContact]: 'Cập nhật liên hệ',
  [WorkflowNodeCode.CallAPIWebhook]: 'Gọi đến API/Webhook',
  [WorkflowNodeCode.Branch]: 'Nhánh',
  [WorkflowNodeCode.Delay]: 'Thời gian chờ',
  [WorkflowNodeCode.Wait]: 'Chờ tới ngày cụ thể',
  [WorkflowNodeCode.End]: 'Kết thúc',
})

export const WorkflowWaitNodes = [
  {
    code: WorkflowNodeCode.Delay,
    title: WorkflowNodeContext[WorkflowNodeCode.Delay],
    description: 'Đợi sau x (ngày, giờ, phút, giây) thì đi tiếp kịch bản',
    disabled: false,
  },
  {
    code: WorkflowNodeCode.Wait,
    title: WorkflowNodeContext[WorkflowNodeCode.Wait],
    description: 'Đợi sau x (ngày, giờ, phút, giây) thì đi tiếp kịch bản',
    disabled: false,
  },
]

export const WorkflowNodes = [
  {
    code: WorkflowNodeCode.CreateTicket,
    title: WorkflowNodeContext[WorkflowNodeCode.CreateTicket],
    description: 'Tạo một ticket mới trên hệ thống',
    disabled: false,
  },
  {
    code: WorkflowNodeCode.UpdateTicket,
    title: WorkflowNodeContext[WorkflowNodeCode.UpdateTicket],
    description:
      'Cập nhật ticket thoả điều kiện từ sự kiện/điều kiện hoặc ticket được chỉ định',
    disabled: false,
  },
  {
    code: WorkflowNodeCode.SendEmail,
    title: WorkflowNodeContext[WorkflowNodeCode.SendEmail],
    description: 'Gửi Email đến danh sách nhận đi kèm với mẫu Email cụ thể vớ',
    disabled: false,
  },
  {
    code: WorkflowNodeCode.SendSms,
    title: WorkflowNodeContext[WorkflowNodeCode.SendSms],
    description:
      'Gửi SMS Brandname đến danh sách số điện thoại từ sự kiện/điều kiện hoặc các số điện thoại được chỉ định sẵn',
    disabled: false,
  },
  {
    code: WorkflowNodeCode.SenZns,
    title: WorkflowNodeContext[WorkflowNodeCode.SenZns],
    description:
      'Gửi ZNS Brandname đến danh sách số điện thoại từ sự kiện/điều kiện hoặc các số điện thoại được chỉ định sẵn',
    disabled: false,
  },
  {
    code: WorkflowNodeCode.SendFacebook,
    title: WorkflowNodeContext[WorkflowNodeCode.SendFacebook],
    description: '',
    disabled: true,
  },
  {
    code: WorkflowNodeCode.SendLiveChat,
    title: WorkflowNodeContext[WorkflowNodeCode.SendLiveChat],
    description: '',
    disabled: true,
  },
  {
    code: WorkflowNodeCode.SendZalo,
    title: WorkflowNodeContext[WorkflowNodeCode.SendZalo],
    description: '',
    disabled: true,
  },
  {
    code: WorkflowNodeCode.PushNotification,
    title: WorkflowNodeContext[WorkflowNodeCode.PushNotification],
    description:
      'Gửi Push đến danh sách tài khoản Agent hoặc khách hàng từ sự kiện/điều kiện hoặc các liên hệ được chỉ định sẵn',
    disabled: false,
  },
  {
    code: WorkflowNodeCode.CallBot,
    title: WorkflowNodeContext[WorkflowNodeCode.CallBot],
    description:
      'Gọi bằng Callbot đến danh sách số điện thoại từ sự kiện/điều kiện hoặc các số điện thoại được chỉ định sẵn',
    disabled: true,
  },
  {
    code: WorkflowNodeCode.CreateContact,
    title: WorkflowNodeContext[WorkflowNodeCode.CreateContact],
    description: 'Tạo một liên hệ mới trên hệ thống',
    disabled: true,
  },
  {
    code: WorkflowNodeCode.UpdateContact,
    title: WorkflowNodeContext[WorkflowNodeCode.UpdateContact],
    description:
      'Cập nhật liên hệ thoả điều kiện từ sự kiện/điều kiện hoặc liên hệ được chỉ định',
    disabled: true,
  },
  {
    code: WorkflowNodeCode.CallAPIWebhook,
    title: WorkflowNodeContext[WorkflowNodeCode.CallAPIWebhook],
    description: 'Gọi đến API hoặc Webhook của đối tác, khách hàng',
    disabled: false,
  },
  {
    code: WorkflowNodeCode.Branch,
    title: WorkflowNodeContext[WorkflowNodeCode.Branch],
    description: '',
    disabled: false,
  },
]

export const WorkflowZoomCode = Object.freeze({
  ZoomTo200: 'zoomTo200',
  ZoomTo100: 'zoomTo100',
  ZoomTo75: 'zoomTo75',
  ZoomTo50: 'zoomTo50',
  ZoomToFit: 'zoomToFit',
})

export const WorkflowZoomOptions = [
  { value: WorkflowZoomCode.ZoomTo200, label: '200%' },
  { value: WorkflowZoomCode.ZoomTo100, label: '100%' },
  { value: WorkflowZoomCode.ZoomTo75, label: '75%' },
  { value: WorkflowZoomCode.ZoomTo50, label: '50%' },
  { value: WorkflowZoomCode.ZoomToFit, label: 'Zoom To Fit' },
]

export const WorkflowControlMode = Object.freeze({
  Pointer: 'pointer',
  Hand: 'hand',
})

export const WorkflowControlModeContext = Object.freeze({
  [WorkflowControlMode.Pointer]: 'Pointer',
  [WorkflowControlMode.Hand]: 'Hand',
})

export const WorkflowNodeTypes = Object.freeze({
  Custom: 'Custom',
})

export const WorkflowEdgeTypes = Object.freeze({
  Custom: 'Custom',
})

export const WorkflowEventCode = Object.freeze({
  TicketCreate: 'TicketCreate',
  TicketUpdate: 'TicketUpdate',
})

export const WorkflowEventContext = Object.freeze({
  [WorkflowEventCode.TicketCreate]: 'Khi một ticket được tạo',
  [WorkflowEventCode.TicketUpdate]: 'Khi một ticket được cập nhật',
})

export const WorkflowRuleRelation = Object.freeze({
  And: 'and',
  Or: 'or',
})

export const WorkflowRuleRelationContext = Object.freeze({
  [WorkflowRuleRelation.And]: 'And',
  [WorkflowRuleRelation.Or]: 'Or',
})

export const WorkflowSettingConditionType = Object.freeze({
  ObjectCreate: 'create',
  ObjectUpdate: 'update',
})

export const workflowSettingConditionTypeContext = Object.freeze({
  [WorkflowSettingConditionType.ObjectCreate]: 'Tạo',
  [WorkflowSettingConditionType.ObjectUpdate]: 'Cập nhật',
})

export const WorkflowSettingConditionTypeOptions = [
  {
    value: WorkflowSettingConditionType.ObjectCreate,
    original_value: WorkflowSettingConditionType.ObjectCreate,
    label:
      workflowSettingConditionTypeContext[
        WorkflowSettingConditionType.ObjectCreate
      ],
  },
  {
    value: WorkflowSettingConditionType.ObjectUpdate,
    original_value: WorkflowSettingConditionType.ObjectUpdate,
    label:
      workflowSettingConditionTypeContext[
        WorkflowSettingConditionType.ObjectUpdate
      ],
  },
]

export const WorkflowRuleOperator = Object.freeze({
  Equal: 'eq',
  NotEqual: 'neq',
  Between: 'between',
  Before: 'before',
  After: 'after',
  Exist: 'exist',
  NotExist: 'not_exist',
  Great: 'gt',
  Less: 'lt',
  GreatThan: 'gte',
  LessThan: 'lte',
  Some: 'some',
  Every: 'every',
  NotSome: 'not_some',
  NotEvery: 'not_every',
})

export const WorkflowRuleOperatorContext = Object.freeze({
  [WorkflowRuleOperator.Equal]: 'Bằng',
  [WorkflowRuleOperator.NotEqual]: 'Không bằng',
  [WorkflowRuleOperator.Before]: 'Trước',
  [WorkflowRuleOperator.After]: 'Sau',
  [WorkflowRuleOperator.Exist]: 'Có giá trị',
  [WorkflowRuleOperator.NotExist]: 'Không có giá trị',
  [WorkflowRuleOperator.Great]: 'Lớn hơn',
  [WorkflowRuleOperator.Less]: 'Nhỏ hơn',
  [WorkflowRuleOperator.GreatThan]: 'Lớn hơn hoặc bằng',
  [WorkflowRuleOperator.LessThan]: 'Nhỏ hơn hoặc bằng',
  [WorkflowRuleOperator.Some]: 'Chứa bất kỳ giá trị nào trong',
  [WorkflowRuleOperator.Every]: 'Chứa tất cả các giá trị trong',
  [WorkflowRuleOperator.NotSome]: 'Không chứa bất kỳ giá trị nào trong',
  [WorkflowRuleOperator.NotEvery]: 'Không chứa tất cả giá trị nào trong',
})

export const DefaultRuleOperatorOptions = [
  {
    value: WorkflowRuleOperator.Equal,
    label: WorkflowRuleOperatorContext[WorkflowRuleOperator.Equal],
  },
  {
    value: WorkflowRuleOperator.NotEqual,
    label: WorkflowRuleOperatorContext[WorkflowRuleOperator.NotEqual],
  },
  {
    value: WorkflowRuleOperator.Exist,
    label: WorkflowRuleOperatorContext[WorkflowRuleOperator.Exist],
  },
  {
    value: WorkflowRuleOperator.NotExist,
    label: WorkflowRuleOperatorContext[WorkflowRuleOperator.NotExist],
  },
  {
    value: WorkflowRuleOperator.Some,
    label: WorkflowRuleOperatorContext[WorkflowRuleOperator.Some],
  },
  {
    value: WorkflowRuleOperator.Every,
    label: WorkflowRuleOperatorContext[WorkflowRuleOperator.Every],
  },
  {
    value: WorkflowRuleOperator.NotSome,
    label: WorkflowRuleOperatorContext[WorkflowRuleOperator.NotSome],
  },
  {
    value: WorkflowRuleOperator.NotEvery,
    label: WorkflowRuleOperatorContext[WorkflowRuleOperator.NotEvery],
  },
]

export const DateTimeRuleOperatorOptions = [
  {
    value: WorkflowRuleOperator.Equal,
    label: WorkflowRuleOperatorContext[WorkflowRuleOperator.Equal],
  },
  {
    value: WorkflowRuleOperator.Before,
    label: WorkflowRuleOperatorContext[WorkflowRuleOperator.Before],
  },
  {
    value: WorkflowRuleOperator.After,
    label: WorkflowRuleOperatorContext[WorkflowRuleOperator.After],
  },
  {
    value: WorkflowRuleOperator.Exist,
    label: WorkflowRuleOperatorContext[WorkflowRuleOperator.Exist],
  },
  {
    value: WorkflowRuleOperator.NotExist,
    label: WorkflowRuleOperatorContext[WorkflowRuleOperator.NotExist],
  },
]

export const ActionRuleOperatorOptions = [
  {
    value: WorkflowRuleOperator.Equal,
    label: WorkflowRuleOperatorContext[WorkflowRuleOperator.Equal],
  },
]

export const ActionFieldCode = 'action'
export const ActionFieldLabel = 'Đối tượng'

export const NumberRuleOperatorOptions = [
  {
    value: WorkflowRuleOperator.Equal,
    label: WorkflowRuleOperatorContext[WorkflowRuleOperator.Equal],
  },
  {
    value: WorkflowRuleOperator.NotEqual,
    label: WorkflowRuleOperatorContext[WorkflowRuleOperator.NotEqual],
  },
  {
    value: WorkflowRuleOperator.Exist,
    label: WorkflowRuleOperatorContext[WorkflowRuleOperator.Exist],
  },
  {
    value: WorkflowRuleOperator.NotExist,
    label: WorkflowRuleOperatorContext[WorkflowRuleOperator.NotExist],
  },
  {
    value: WorkflowRuleOperator.Great,
    label: WorkflowRuleOperatorContext[WorkflowRuleOperator.Great],
  },
  {
    value: WorkflowRuleOperator.Less,
    label: WorkflowRuleOperatorContext[WorkflowRuleOperator.Less],
  },
  {
    value: WorkflowRuleOperator.GreatThan,
    label: WorkflowRuleOperatorContext[WorkflowRuleOperator.GreatThan],
  },
  {
    value: WorkflowRuleOperator.LessThan,
    label: WorkflowRuleOperatorContext[WorkflowRuleOperator.LessThan],
  },
  {
    value: WorkflowRuleOperator.Some,
    label: WorkflowRuleOperatorContext[WorkflowRuleOperator.Some],
  },
  {
    value: WorkflowRuleOperator.Every,
    label: WorkflowRuleOperatorContext[WorkflowRuleOperator.Every],
  },
  {
    value: WorkflowRuleOperator.NotSome,
    label: WorkflowRuleOperatorContext[WorkflowRuleOperator.NotSome],
  },
  {
    value: WorkflowRuleOperator.NotEvery,
    label: WorkflowRuleOperatorContext[WorkflowRuleOperator.NotEvery],
  },
]

export const WorkflowDateTimeValueUnit = Object.freeze({
  Day: 'days',
  Hour: 'hours',
  Minute: 'minutes',
})

export const WorkflowDateTimeValueUnitContext = Object.freeze({
  [WorkflowDateTimeValueUnit.Day]: 'Ngày',
  [WorkflowDateTimeValueUnit.Hour]: 'Giờ',
  [WorkflowDateTimeValueUnit.Minute]: 'Phút',
})

export const WorkflowDateTimeValueUnitOptions = [
  {
    value: WorkflowDateTimeValueUnit.Day,
    label: WorkflowDateTimeValueUnitContext[WorkflowDateTimeValueUnit.Day],
  },
  {
    value: WorkflowDateTimeValueUnit.Hour,
    label: WorkflowDateTimeValueUnitContext[WorkflowDateTimeValueUnit.Hour],
  },
  {
    value: WorkflowDateTimeValueUnit.Minute,
    label: WorkflowDateTimeValueUnitContext[WorkflowDateTimeValueUnit.Minute],
  },
]

export const WorkflowDateConditionType = Object.freeze({
  Date: 'date',
  OffsetDate: 'offset_date',
})

export const WorkflowNodeWaitType = Object.freeze({
  OffsetTime: 'offset_time',
  SpecificTime: 'specific_time',
})

// Email

export const WorkflowEmailReceiverType = Object.freeze({
  Other: 'other',
  Requester: 'requester_id',
  AssignAgent: 'assign_agent_id',
})

export const WorkflowEmailReceiverTypeOptions = [
  {
    value: WorkflowEmailReceiverType.Other,
    label: 'Chuyên viên khác',
  },
  {
    value: WorkflowEmailReceiverType.Requester,
    label: 'Người yêu cầu',
  },
  {
    value: WorkflowEmailReceiverType.AssignAgent,
    label: 'Chuyên viên xử lý',
  },
]

export const WorkflowEmailCc = Object.freeze({
  CC: 'cc',
  Followers: 'followers',
  Group: 'group_id',
  Other: 'other',
})

export const WorkflowEmailCCOptions = [
  {
    value: WorkflowEmailCc.CC,
    label: 'CC',
  },
  {
    value: WorkflowEmailCc.Followers,
    label: 'Người theo dõi',
  },
  {
    value: WorkflowEmailCc.Group,
    label: 'Tổ chức (Toàn bộ email)',
  },
  {
    value: WorkflowEmailCc.Other,
    label: 'Danh sách Email',
  },
]

export const WorkflowHistoryEventCode = Object.freeze({
  NodeConnect: 'NodeConnect',
  NodeAdd: 'NodeAdd',
  NodeDelete: 'NodeDelete',
  NodeChange: 'NodeChange',
  NodePaste: 'NodePaste',
})

export const WorkflowHistoryEventContext = Object.freeze({
  [WorkflowHistoryEventCode.NodeConnect]: 'Kết nối khối',
  [WorkflowHistoryEventCode.NodeAdd]: 'Thêm khối',
  [WorkflowHistoryEventCode.NodeDelete]: 'Xóa khối',
  [WorkflowHistoryEventCode.NodePaste]: 'Dán khối',
})

export const WorkflowNodeStatus = Object.freeze({
  Invalid: 'invalid',
})

export const WorkflowSmsZnsTo = Object.freeze({
  Customer: 'requester',
  Agent: 'assign_agent',
})

export const WorkflowSmsZnsToOptions = [
  {
    value: WorkflowSmsZnsTo.Customer,
    label: 'Khách hàng',
  },
  {
    value: WorkflowSmsZnsTo.Agent,
    label: 'Chuyên viên',
  },
]

export const WorkflowChatFrom = Object.freeze({
  Chatbot: 'chatbot',
  Agent: 'agent',
})

export const WorkflowChatSendFromOptions = [
  {
    value: WorkflowChatFrom.Chatbot,
    label: 'Hệ thống (Chatbot)',
  },
  {
    value: WorkflowChatFrom.Agent,
    label: 'Chuyên viên',
  },
]

export const WorkflowPushNotificationTo = Object.freeze({
  AssignAgent: 'assign_agent_id',
  Follow: 'follow_users',
  Cc: 'cc_users',
  Admin: 'admin',
  Leader: 'leader',
  Supervisor: 'supervisor',
})

export const WorkflowPushNotificationToOptions = [
  {
    value: WorkflowPushNotificationTo.AssignAgent,
    label: 'Người xử lý',
  },
  {
    value: WorkflowPushNotificationTo.Follow,
    label: 'Người theo dõi',
  },
  {
    value: WorkflowPushNotificationTo.Cc,
    label: 'Người cc',
  },
  {
    value: WorkflowPushNotificationTo.Admin,
    label: 'Admin',
  },
  {
    value: WorkflowPushNotificationTo.Leader,
    label: 'Leader',
  },
  {
    value: WorkflowPushNotificationTo.Supervisor,
    label: 'Supervisor',
  },
]

export const WorkflowRunStatus = Object.freeze({
  Waiting: 'waiting',
  Running: 'running',
  Complete: 'completed',
  Failed: 'failed',
  Cancel: 'cancel',
})

export const WorkflowRunStatusContext = Object.freeze({
  [WorkflowRunStatus.Waiting]: 'Đang chờ',
  [WorkflowRunStatus.Running]: 'Đang chạy',
  [WorkflowRunStatus.Complete]: 'Hoàn thành',
  [WorkflowRunStatus.Failed]: 'Thất bại',
  [WorkflowRunStatus.Cancel]: 'Hủy',
})

export const WorkflowRunStatusOptions = [
  {
    value: WorkflowRunStatus.Waiting,
    label: WorkflowRunStatusContext[WorkflowRunStatus.Waiting],
  },
  {
    value: WorkflowRunStatus.Running,
    label: WorkflowRunStatusContext[WorkflowRunStatus.Running],
  },
  {
    value: WorkflowRunStatus.Complete,
    label: WorkflowRunStatusContext[WorkflowRunStatus.Complete],
  },
  {
    value: WorkflowRunStatus.Failed,
    label: WorkflowRunStatusContext[WorkflowRunStatus.Failed],
  },
  {
    value: WorkflowRunStatus.Cancel,
    label: WorkflowRunStatusContext[WorkflowRunStatus.Cancel],
  },
]

export const WorkflowWebhookHttpMethod = Object.freeze({
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  PATCH: 'PATCH',
  DELETE: 'DELETE',
})

export const WorkflowWebhookHttpMethodOptions = [
  { label: 'GET', value: WorkflowWebhookHttpMethod.GET },
  { label: 'POST', value: WorkflowWebhookHttpMethod.POST },
  { label: 'PUT', value: WorkflowWebhookHttpMethod.PUT },
  { label: 'PATCH', value: WorkflowWebhookHttpMethod.PATCH },
  { label: 'DELETE', value: WorkflowWebhookHttpMethod.DELETE },
]
